import { connect } from 'react-redux'
import { connectWaiter, getWaiter } from 'redux-waiter'
import { compose } from 'recompose'
import { clearModal } from '@hixme/modal'
import { BENEFIT_TYPE_GROUP_HEALTH } from '@hixme/benefit-types'
import { getClientBenefits } from 'modules/api/client-benefits-get'

// project
import DeclineCoverageModal from 'components/DeclineCoverageModal'
import { createErrorNotification } from 'modules/notification-manager/actions'

// store
import cart from 'store/modules/cart'
import person from 'store/modules/persons'
import userSession from 'store/modules/user-session'

// module
import { constants } from '../modules/grouphealth-coverage'

const mapStateToProps = (state) => {
  const waiter = getWaiter(state, constants.GET_VISION_PLANS)
  return {
    enrollmentKey: userSession.selectors.getEnrollmentPublicKey(state),
    benefitProducts: (waiter.response && waiter.response.ClientBenefits) || [],
    coveredPersons: [
      person.selectors.getPersonSelector(state),
      ...person.selectors.getDependentsEligibleForBenefits(state),
    ],
    isProcessing: getWaiter(state, cart.constants.CART_GROUPHEALTH_POST).isPending || false,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onDeclineClick: (coveredPersons, benefitProducts) => {
    dispatch(cart.actions.declineGroupHealthProduct(coveredPersons, benefitProducts)).then(
      () => {
        dispatch(clearModal())
        dispatch(userSession.actions.pushNextBenefitRoute())
      },
      () => {
        dispatch(clearModal())
        dispatch(
          createErrorNotification('There was an error declining group health. Please try again.')
        )
      }
    )
  },
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  connectWaiter({
    name: constants.GET_GROUPHEALTH_PLANS,
    requestCreator: ({ EnrollmentPublicKey }) =>
      getClientBenefits({
          EnrollmentPublicKey,
          BenefitType: BENEFIT_TYPE_GROUP_HEALTH,
        }),
    requestOnMountParams: ({ enrollmentKey }) => ({
      EnrollmentPublicKey: enrollmentKey,
    }),
  })
)(DeclineCoverageModal)
